"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _EventsModule = _interopRequireDefault(require("./Events.module.css"));

var _grommet = require("grommet");

var staticImages = _interopRequireWildcard(require("../staticImages"));

var _Event = _interopRequireDefault(require("./Event"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Events = /*#__PURE__*/function (_React$Component) {
  _inherits(Events, _React$Component);

  var _super = _createSuper(Events);

  function Events(props) {
    var _this;

    _classCallCheck(this, Events);

    _this = _super.call(this, props);
    _this.state = {
      events: [],
      liveEvents: [],
      pastEvents: [],
      futureEvents: [],
      curTime: Math.round(Date.now() / 1000)
    };
    return _this;
  }

  _createClass(Events, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var events = [];

      for (var i = 0; i < this.props.events.length; ++i) {
        if (this.props.zoom[this.props.events[i].uuid] !== undefined) {
          events.push(this.props.events[i]);
        }
      }

      var past = [];
      var live = [];
      var future = [];
      this.props.getClubEvents(this.props.clubUUID, function (data) {
        for (var _i = 0; _i < data.length; _i++) {
          if (!data[_i].officialEvent) {
            events.push(data[_i]);
          }
        }

        events.sort(function (a, b) {
          return a.time[0].toString().localeCompare(b.time[0].toString());
        });

        for (var _i2 = 0; _i2 < events.length; _i2++) {
          if (events[_i2].time[0] < _this2.state.curTime && _this2.state.curTime < events[_i2].time[1]) {
            live.push(_i2);
          } else if (_this2.state.curTime >= events[_i2].time[1]) {
            past.push(_i2);
          } else {
            future.push(_i2);
          }
        }

        _this2.setState({
          events: events,
          liveEvents: live,
          pastEvents: past,
          futureEvents: future
        });
      });
      this.setState({
        events: events,
        liveEvents: live,
        pastEvents: past,
        futureEvents: future
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (this.state.events.length === 0) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: _EventsModule["default"].padding
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _EventsModule["default"].outer_div
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _EventsModule["default"].inner_div
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _EventsModule["default"].no_event
        }, "No Events Left"), /*#__PURE__*/_react["default"].createElement("img", {
          id: _EventsModule["default"].no_events,
          src: staticImages.NO_EVENTS,
          alt: "Calendar Icon"
        }))));
      } else if (this.state.liveEvents.length === 1 && this.state.events.length === 1) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: _EventsModule["default"].padding
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _EventsModule["default"].outer_div,
          style: {
            background: "#1455A6"
          }
        }, /*#__PURE__*/_react["default"].createElement(_Event["default"], {
          type: "Single Live",
          color: this.props.color,
          event: this.state.events[0],
          zoom: this.props.zoom[this.state.events[0].uuid],
          token: this.props.token,
          live: true,
          timezone: this.props.timezone,
          addToCal: this.props.addToCal,
          errorPopup: this.props.errorPopup,
          authenticator: this.props.authenticator,
          name: this.props.name,
          editMailingList: this.props.editMailingList
        })));
      } else {
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: _EventsModule["default"].padding
        }, /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
          id: _EventsModule["default"].outer_div
        }, this.state.liveEvents.length === 0 && this.state.events.length > 4 || this.state.events.length > 5 ? /*#__PURE__*/_react["default"].createElement("div", {
          id: _EventsModule["default"].shadow
        }) : /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", {
          id: _EventsModule["default"].list_div
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _EventsModule["default"].inner_list_div
        }, this.state.liveEvents.map(function (index, i) {
          return /*#__PURE__*/_react["default"].createElement("div", null, i === 0 ? /*#__PURE__*/_react["default"].createElement("div", null) : /*#__PURE__*/_react["default"].createElement(_Event["default"], {
            key: index,
            color: "#1455A6",
            event: _this3.state.events[index],
            zoom: _this3.props.zoom[_this3.state.events[index].uuid],
            token: _this3.props.token,
            live: true,
            timezone: _this3.props.timezone,
            addToCal: _this3.props.addToCal,
            editMailingList: _this3.props.editMailingList
          }));
        }), this.state.futureEvents.map(function (index) {
          return /*#__PURE__*/_react["default"].createElement(_Event["default"], {
            type: "future",
            key: index,
            color: "#2B3443",
            event: _this3.state.events[index],
            token: _this3.props.token,
            live: false,
            timezone: _this3.props.timezone,
            addToCal: _this3.props.addToCal,
            errorPopup: _this3.props.errorPopup,
            authenticator: _this3.props.authenticator,
            zoom: _this3.props.zoom[_this3.state.events[index].uuid],
            name: _this3.props.name,
            editMailingList: _this3.props.editMailingList
          });
        }), this.state.pastEvents.map(function (index) {
          return /*#__PURE__*/_react["default"].createElement(_Event["default"], {
            type: "past",
            key: index,
            color: "rgba(43, 52, 67, 0.5)",
            event: _this3.state.events[index],
            token: _this3.props.token,
            live: false,
            timezone: _this3.props.timezone,
            addToCal: _this3.props.addToCal,
            errorPopup: _this3.props.errorPopup,
            authenticator: _this3.props.authenticator,
            zoom: _this3.props.zoom[_this3.state.events[index].uuid],
            name: _this3.props.name,
            editMailingList: _this3.props.editMailingList
          });
        }), this.state.liveEvents.length === 0 && this.state.events.length >= 4 || this.state.events.length >= 5 ?
        /*#__PURE__*/

        /*<div id={styles.cover}></div> */
        _react["default"].createElement("div", null) : /*#__PURE__*/_react["default"].createElement("div", {
          id: _EventsModule["default"].outer
        }))), this.state.liveEvents.length === 0 ? /*#__PURE__*/_react["default"].createElement("div", {
          id: _EventsModule["default"].events
        }, "Events") : /*#__PURE__*/_react["default"].createElement("div", {
          id: _EventsModule["default"].top_live
        }, /*#__PURE__*/_react["default"].createElement(_Event["default"], {
          color: this.props.color,
          event: this.state.events[this.state.liveEvents[0]],
          zoom: this.props.zoom[this.state.events[this.state.liveEvents[0]].uuid],
          token: this.props.token,
          live: true,
          type: "Top Live",
          timezone: this.props.timezone,
          addToCal: this.props.addToCal,
          errorPopup: this.props.errorPopup,
          authenticator: this.props.authenticator,
          name: this.props.name,
          editMailingList: this.props.editMailingList
        }))));
      }
    }
  }]);

  return Events;
}(_react["default"].Component);

var _default = Events;
exports["default"] = _default;

//# sourceMappingURL=Events.js.map